export const placeholders = [
  "Emma",
  "Olivia",
  "Sophia",
  "Ava",
  "Isabella",
  "Mia",
  "Charlotte",
  "Amelia",
  "Harper",
  "Evelyn",
  "Abigail",
  "Emily",
  "Elizabeth",
  "Sofia",
  "Avery",
  "Ella",
  "Scarlett",
  "Grace",
  "Chloe",
  "Victoria",
  "Riley",
  "Aria",
  "Lily",
  "Aubrey",
  "Zoey",
  "Penelope",
  "Layla",
  "Lillian",
  "Natalie",
  "Hannah",
  "Leah",
  "Zoe",
  "Stella",
  "Hazel",
  "Ellie",
  "Paisley",
  "Audrey",
  "Skylar",
  "Violet",
  "Claire",
  "Bella",
  "Aurora",
  "Lucy",
  "Anna",
  "Samantha",
  "Caroline",
  "Genesis",
  "Aaliyah",
  "Kennedy",
  "Kinsley",
  "Maya",
  "Madelyn",
  "Savannah",
  "Peyton",
  "Nora",
  "Ruby",
  "Serenity",
  "Autumn",
  "Adeline",
  "Hailey",
  "Gianna",
  "Naomi",
  "Ariana",
  "Gabriella",
  "Eleanor",
  "Alice",
  "Catherine",
  "Josephine",
  "Sadie",
  "Willow",
  "Alexandra",
  "Isabelle",
  "Mackenzie",
  "Ivy",
  "Jasmine",
  "Maria",
  "Julia",
  "Valentina",
  "Brielle",
  "Piper",
  "Rylee",
  "Delilah",
  "Reagan",
  "Emilia",
  "Melanie",
  "Lydia",
  "Kylie",
  "Clara",
  "Vivian",
  "Jade",
  "Rachel",
  "Madeline",
  "Quinn",
  "Trinity",
  "Diana",
  "Nicole",
  "Tessa",
  "Fiona",
  "Rosalie",
  "Juliette",
];
